import React from "react";

import Header from "../Header/Header";
import Navbar from "../Navbar/Navbar";

const Home = () => {
  return (
    <div>
      <Navbar />

      <Header />
    </div>
  );
};

export default Home;
